import { IPaginationPayload, ISortPayload } from "./types"

export const DEFAULT_PAGINATION: IPaginationPayload = { page: 1, perPage: 25 }
export const DEFAULT_SORT: ISortPayload = { field: "id", order: "asc" }

export const DEFAULT_CREATEGETLISTHOOK_CONFIG = {
  queryKey: ["fallback-querykey"],
}
